module.exports = __webpack_public_path__ + "static/WOM-987162f5940fa66222408e15af8e485b.png";